export default __webpack_public_path__ + "appointments/static/media/blue.bb712b56.png";